export const iconFontAwesomePoliticalCircleDollarToSlot = (
	<i className="fa-solid fa-circle-dollar-to-slot"></i>
);
